import domReady from '@wordpress/dom-ready';

function initVideoPlayer(videoPlayerEl) {
  const playButton = videoPlayerEl.querySelector('.play');
  const iframe = videoPlayerEl.querySelector('.youtube-iframe');

  if (!playButton || !iframe) return;

  function playVideo() {
    videoPlayerEl.classList.add('is-playing');

    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
      'https://www.youtube.com'
    );
  }

  playButton.addEventListener('click', playVideo);
  playButton.addEventListener('keydown', (event) => {
    if ('Enter' === event.key || ' ' === event.key) {
      event.preventDefault();
      playVideo();
    }
  });
}

domReady(() => {
  document.querySelectorAll('[data-component="videoPlayer"]').forEach(initVideoPlayer);
});
